import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { castStringToEnum } from '../../service/CastHelpers';
import { getTitleForDayBudgetMode } from '../../service/TextStoreHelpers/TextStoreHelpers';
import { RawDayBudgetValue, WalletDayBudgetValue } from '../../typings/budget';
import { CurrencyCode, GdCampaignBudgetShowMode, GdWalletBudgetType } from '../../typings/graphql-grid';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { DayBudgetEditor } from '../DayBudgetEditor/DayBudgetEditor';
import { ErrorItemText } from '../ErrorsPresenter/ErrorsPresenter';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import './DayBudgetEditPopup.css';
import * as keyset from './DayBudgetEditPopup.i18n';

const i18n = i18nFactory(keyset);

export interface DayBudgetEditPopupProps {
    walletBudget?: WalletDayBudgetValue;
    value: RawDayBudgetValue;
    currency: CurrencyCode;
    error?: ErrorItemText;
    onSave: () => void;
    onCancel: () => void;
    onChange: (value: RawDayBudgetValue) => void;
    anchor: React.ReactNode;
    isVisible: boolean;
    isInProgress: boolean;
}

export class DayBudgetEditPopup extends React.PureComponent<DayBudgetEditPopupProps> {
    render() {
        const { currency, value, walletBudget, onCancel, anchor, isVisible, error, onChange } = this.props;

        let popupHint;

        if (
            walletBudget !== undefined &&
            walletBudget.mode !== undefined &&
            walletBudget.sum !== undefined &&
            walletBudget.type === GdWalletBudgetType.DAY_BUDGET
        ) {
            popupHint = i18n('walletDayBudgetIsSet', {
                mode: getTitleForDayBudgetMode(castStringToEnum(walletBudget.mode, GdCampaignBudgetShowMode)),
                sum: walletBudget.sum,
                currency: mapStringToCurrencySymbol(currency)
            });
        }

        return (
            <PopupDecorator
                cls={Bem.cls('day-budget-edit-popup')}
                visible={isVisible}
                anchor={anchor}
                target="anchor"
                directions={['bottom-center', 'top-center', 'left-center', 'right-center']}
                hasTail={true}
                onOutsideClick={onCancel}
                header={this.getHeader()}
                popupHint={popupHint}
                footer={this.getFooter()}
            >
                <DayBudgetEditor currency={currency} value={value} error={error} onChange={onChange} />
            </PopupDecorator>
        );
    }

    private getFooter = () => {
        const { onSave, isInProgress, onCancel } = this.props;

        return [
            <ButtonDecorator
                theme={'action'}
                view="default"
                tone="default"
                size={'n'}
                text={i18n('set')}
                progress={isInProgress}
                onClick={onSave}
                key={1}
            />,

            <ButtonDecorator
                theme={'pseudo'}
                view="default"
                tone="default"
                size={'n'}
                text={i18n('cancel')}
                onClick={onCancel}
                key={2}
                cls={Bem.cls('day-budget-edit-popup', 'button-cancel')}
            />
        ];
    };

    private getHeader = () => i18n('dayBudgetLimit');
}
